import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    // Countdown timer
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-50 dark:from-gray-900 dark:to-gray-800 flex items-center justify-center p-4">
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl p-8 max-w-md w-full text-center">
        <div className="mb-6">
          <CheckCircle className="w-20 h-20 text-green-500 mx-auto" />
        </div>
        
        <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mb-4">
          🎉 Zahlung erfolgreich!
        </h1>
        
        <p className="text-gray-600 dark:text-gray-400 mb-6">
          Vielen Dank! Dein AlpenScreen Account wurde erfolgreich aktiviert.
        </p>
        
        <div className="bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-lg p-4 mb-6">
          <p className="text-sm text-green-800 dark:text-green-200">
            ✅ Subscription aktiv<br/>
            ✅ Voller Zugriff freigeschaltet<br/>
            ✅ CHF 5.00 / Monat
          </p>
        </div>

        {sessionId && (
          <p className="text-xs text-gray-500 dark:text-gray-400 mb-4">
            Session: {sessionId.substring(0, 20)}...
          </p>
        )}
        
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-6">
          Weiterleitung zum Dashboard in <strong>{countdown}</strong> Sekunden...
        </p>
        
        <button
          onClick={() => navigate('/')}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-medium transition-colors"
        >
          Jetzt zum Dashboard
        </button>
      </div>
    </div>
  );
};

export default PaymentSuccess;